import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@shared/shared.module';

import { ToolbarModule } from 'primeng/toolbar';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputSwitchModule } from 'primeng/inputswitch';

import { HeaderComponent } from './components/header/header.component';
import { BreadcrumbsComponent } from './components/breadcrumbs.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { UserAvatarComponent } from './components/user-avatar.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { MenuProfileComponent } from './components/menu-profile/menu-profile.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { TabViewModule } from 'primeng/tabview';
import { FooterComponent } from '@layout/components/footer/footer.component';

@NgModule({
    declarations: [
        HeaderComponent,
        BreadcrumbsComponent,
        ToolbarComponent,
        UserAvatarComponent,
        NotificationsComponent,
        MenuProfileComponent,
        MobileMenuComponent,
        FooterComponent,
    ],
    exports: [HeaderComponent, BreadcrumbsComponent, MobileMenuComponent, FooterComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,

        ToolbarModule,
        ButtonModule,
        BreadcrumbModule,
        SidebarModule,
        OverlayPanelModule,
        InputSwitchModule,
        TabViewModule,
    ],
})
export class LayoutModule {}
